import { ErrorHandler } from '@frontend/error-handler';
import { CommonMessage } from '@frontend/lang';
import { useActiveModal, useModals } from '@frontend/modal';
import { ScheduleClient } from '@frontend/report/api';
import { CreateSchedule } from '@frontend/report/types';
import { useAccountRepository } from '@frontend/repository';
import { ToastUtil } from '@frontend/toast-utils';
import { useState } from 'react';

import { CreateScheduleModalProps } from './create-schedule-modal.component';

export const useCreateScheduleModal = (props: CreateScheduleModalProps) => {
    const { currentAccount } = useAccountRepository();
    const { modalId } = useActiveModal();
    const { closeModal } = useModals();
    const [formValues, setFormValues] = useState<CreateSchedule>({});

    const onCancel = () => {
        closeModal(modalId);
    };

    const onSubmit = () => {
        ScheduleClient.postSchedule(currentAccount, props.report_id, formValues)
            .then(() => {
                onCancel();
                ToastUtil.success(CommonMessage.FORMS.SUCCESSFULLY_CREATED_ENTITY(CommonMessage.OBJECTS.SCHEDULE.DEFAULT));
            })
            .catch((err) => ErrorHandler.handleError({ error: err }));
    };
    return {
        formValues,
        setFormValues,
        onSubmit,
        onCancel
    };
};
